import Vue from 'vue';

const state = {
  selectedTabByPath: {},
};

const getters = {
  selectedTab(state, { path, selectedTabIndex }) {
    const selectedTab = state.selectedTabByPath[path];
    return selectedTab ? selectedTab[selectedTabIndex] : null;
  },
};
const mutations = {
  setSelectedTab(state, { path, selectedTabIndex }) {
    Vue.set(state.selectedTabByPath, path, selectedTabIndex);
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
